<div class="flex flex-row flex-wrap justify-content-center pt-8">
    <div class="surface-card p-4 shadow-2 border-round w-full lg:w-6">
        <div class="text-center mb-5">
            <div class="text-900 text-3xl font-medium mb-3">Welcome Back</div>
        </div>

        <div class="flex w-full justify-content-center">
            <a [routerLink]="['/dashboard']">
                <p-button class="w-full" pRipple>
                    <fa-icon [icon]="['far', 'user']" class="mr-2"></fa-icon>
                    Go to dashboard
                </p-button>
            </a>
        </div>
    </div>
</div>
